import { API } from '../api'
import { ContractsResponse } from './interface'

export const post = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const { contractId, ...filtrosRest } = filtros
    const response = await API.post<ContractsResponse>(
      `/contratos/${contractId}/reprocessar`,
      filtrosRest
    )

    return {
      conteudo: response?.content,
      sucesso: response?.isSuccess
    }
  } catch (error) {
    console.error('Erro ao solicitar reprocessamento:', error)
    return {
      conteudo: error,
      sucesso: false
    }
  }
}
